import { type Meta } from '../types/docs';

const META: Meta = {
  description:
    'Tracks when the user clicks an action button (link or contact-support) in the integration details modal',
  name: 'integration_modal_action_clicked',
  params: [
    {
      description: 'The ID of the integration',
      name: 'integration_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The name of the integration',
      name: 'integration_name',
      required: true,
      type: 'string',
    },
    {
      description: 'The section the integration belongs to',
      name: 'integration_section',
      required: true,
      type: 'string',
    },
    {
      description: "The kind of action taken ('link' or 'contact-support')",
      name: 'action_kind',
      required: true,
      type: 'string',
    },
    {
      description: 'The visible label of the action button',
      name: 'action_label',
      required: true,
      type: 'string',
    },
    {
      description: "The position of the button in the modal footer ('primary' or 'secondary')",
      name: 'button_position',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
